import HubSpotInlineForm from "@/components/HubSpotInlineForm";

const NEWSLETTER_FORM_ID = "e49b7f08-4495-4cb4-afa2-b485f007f8a2";

const HeroNewsletterForm = () => {
  return (
    <div className="mt-10 max-w-xl qbd-newsletter-form qbd-newsletter-form--dark qbd-newsletter-form--compact text-left">
      <HubSpotInlineForm formId={NEWSLETTER_FORM_ID} targetId="newsletter-hubspot-form-knowledge-hero" />
    </div>
  );
};

export default HeroNewsletterForm;
